import * as types from './_actionTypes';

const initialState = {
  students: [],
  studentsProgress: [],
  pagination: {
    page: 1,
    limit: 20,
    total: 0,
    pages: 0
  },
  selectedStudents: [],
  filters: {
    search: '',
    status: 'all',
    course: '',
    semester: ''
  },
  loading: false,
  uploading: false,
  uploadResult: null,
  error: null
}

const adminStudentReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch Students
    case types.FETCH_STUDENTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case types.FETCH_STUDENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        students: action.payload.students || action.payload, // ✅ Handle both formats
        pagination: action.payload.pagination || state.pagination,
        error: null
      };
    case types.FETCH_STUDENTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    
    // Upload Students
    case types.UPLOAD_STUDENTS_REQUEST:
      return {
        ...state,
        uploading: true,
        uploadResult: null,
        error: null
      };
    case types.UPLOAD_STUDENTS_SUCCESS:
    
      return {
        ...state,
        uploading: false,
        uploadResult: action.payload, // ✅ Store the upload result
        // ✅ FIXED: Add successful students to the array properly
        students: [
          ...state.students,
          ...(action.payload.successData || []) // Use successData from your saga
        ],
        error: null
      };
    case types.UPLOAD_STUDENTS_FAILURE:
      return {
        ...state,
        uploading: false,
        uploadResult: null,
        error: action.payload
      };
    case types.CLEAR_UPLOAD_RESULT:
      return {
        ...state,
        uploadResult: null,
        error: null
      };
    
    // Update Student
    case types.UPDATE_STUDENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case types.UPDATE_STUDENT_SUCCESS:
      return {
        ...state,
        loading: false,
        students: state.students.map(student => 
          student.id === action.payload.id ? action.payload : student
        ),
        error: null
      };
    case types.UPDATE_STUDENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    
    default:
      return state;
  }
};

export default adminStudentReducer;
